import {
  convertToTimeDropDownValue,
  useFetchData,
  useParseRouteActions,
} from "../../../helpers/GlobalHelper";
import { LmsTimeDropdownOptions } from "../../constants/GlobalConstants";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const MainTable = () => {
  const actionButtons = ["add", "edit", "remove", "export"];
  return (
    <LmsTable
      actionButtons={actionButtons}
      apiSuffix="/inspections/company-project-documents"
      sortable={[
        "Document Log", 
        "Submitted On", 
        "Project No", 
        "Message No", 
        "Error Message",
        "Created On",
        "Created By",
        "Updated On",
        "Updated By",
        "Loan #",
        "Document File Name",
        "Property"
      ]}
      columnLabelsDictionary={{ loanNumber: "Loan #" }}
      columnClickOptions={{
        documentLog: { downloadPath: "document/download", idProp: "documentLogId" },
        loanNumber: { path: "inspections-inspection-company-project-documents/edit", idProp: "id" }
      }}
    />
  );
};

const inspectionCompanyProjectDocumentsFormFields = (myForm, isEdit = false) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField("Inspection Company Project", "inspections/list-inspection-company-projects", {
      name: "nwccprojectId",
      required: true,
      disabled: isEdit
    }),
    myForm.getDropdownField("Document Log", "document/list-document-logs", {
      name: "documentLogId"
    }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Submitted On Date", { name: "submittedOn" }),
    myForm.getDropdownField("Submitted On Time", LmsTimeDropdownOptions, { value: convertToTimeDropDownValue(myForm?.initialValues.submittedOn) }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Error Message", { field: "textarea" }),
  ]);

  return myForm;
};

const inspectionCompanyProjectDocumentFormatter = (data) => {
  const submitDateTime = data.submittedOn ? `${data.submittedOn?.split("T")[0]}${data.submittedOnTimeId ? data.submittedOnTimeId : "T00:00:00"}` : "";
  return {...data, submittedOn: submitDateTime }; 
};

const EditInspectionCompanyProjectDocumentsForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`inspections/company-project-documents/${id}`);
  const myForm = inspectionCompanyProjectDocumentsFormFields(
    new BCFormController(data, { 
      submitSuffix: "inspections/company-project-documents", 
      submitMethod: "PUT", 
      dataFormatterFunc: (data) => inspectionCompanyProjectDocumentFormatter(data),
      clearSuffixesOnSubmit: [`inspections/company-project-documents/${id}`],
      deleteSuffix: "inspections/company-project-documents",
      blankWidth: 2
    }), true
  );

  const formActions = ["save", "save-close", "delete", "close"];
  return (
    <LmsFormGenerator
      myForm={myForm}
      isLoading={isLoading}
      error={error}
      actions={formActions}
    />
  );
};

const AddInspectionCompanyProjectDocumentsForm = () => {
  const myForm = inspectionCompanyProjectDocumentsFormFields(
    new BCFormController({}, { 
      submitSuffix: "inspections/company-project-documents", 
      submitMethod: "POST", 
      dataFormatterFunc: (data) => inspectionCompanyProjectDocumentFormatter(data),
      blankWidth: 2
    })
  );

  const formActions = ["save-new", "save-continue", "save-close", "close"];
  return (<LmsFormGenerator myForm={myForm} actions={formActions} />);
};

const LmsInspectionsInspectionCompanyProjectDocuments = ({
  params = {},
  history,
}) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } =
    useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isAdd && <AddInspectionCompanyProjectDocumentsForm />}
      {isEdit && <EditInspectionCompanyProjectDocumentsForm id={id} />}
    </>
  );
};

export default LmsInspectionsInspectionCompanyProjectDocuments;
